export const TransactionType = Object.freeze({
    INCOME: "income",
    EXPENSE: "expense",
});

export function transactionKey(type, id) {
    return `${type}-${id}`;
}
